import { IDataSource } from "./../../models/IDataSource";

export class DataSourceState {
  dataSources: IDataSource[] = [];
}
